import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotAvailableComponent } from './not-available/not-available.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NotAvailableComponent],
  exports: [NotAvailableComponent]
})
export class NotAvailableModule { }
